import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Box, Drawer, IconButton, Typography, makeStyles, styled } from '@material-ui/core'
import { getDadosUsuario } from 'store/modules/auth/auth.selectors'
import ArrowDropRightLineIcon from 'remixicon-react/ArrowDropRightLineIcon'
import ArrowDropLeftLineIcon from 'remixicon-react/ArrowDropLeftLineIcon'
import { ReactComponent as MainLogo } from 'assets/images/menu/Logo_LK_Menu.svg'
import { VIEW_CLIENT, VIEW_ADMIN, VIEW_AUDITOR } from 'utils/constantes'
import { userItems, adminItems, auditorItems } from './items'

import { NavGroup } from './components'

const drawerWidth = 328

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    'borderRight': `1px solid ${theme.palette.grey.F4}`,
    'boxShadow': `0 ${theme.spacing(1)}px ${theme.spacing(4)}px rgba(15, 52, 68, 0.08)`,
    'scrollbarWidth': 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },

  },
  drawerOpen: {
    width: drawerWidth,
  },
  drawerClosed: {
    width: 100,
  },
}))

const LogoWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  height: 100,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  paddingLeft: theme.spacing(2),
}))

const Title = styled(Typography)(() => ({
  fontSize: 14,
  marginLeft: 8,
  fontWeight: 400,
}))

const Toolbar = styled('div')(({ theme, open }) => ({
  left: open ? 310 : 84,
  zIndex: 10,
  display: 'flex',
  position: 'fixed',
  borderRadius: '50%',
  alignItems: 'center',
  top: theme.spacing(4),
  width: theme.spacing(4),
  justifyContent: 'center',
  height: theme.spacing(4),
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.grey.F4}`,
}))

const SideBar = ({ open, onChange }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const usuario = useSelector(getDadosUsuario)
  const userId = usuario?.tipoUsuario?.id

  const items = useMemo(() => {
    if (VIEW_CLIENT.includes(userId)) return userItems
    if (VIEW_ADMIN.includes(userId)) return adminItems
    if (VIEW_AUDITOR.includes(userId)) return auditorItems
    return []
  }, [userId])

  return (
    <Drawer
      variant='permanent'
      classes={{
        paper: clsx(classes.drawerPaper, {
          [classes.drawerOpen]: open,
          [classes.drawerClosed]: !open,
        }),
      }}>

      <Toolbar open={open}>
        <IconButton onClick={onChange}>
          {open ? <ArrowDropLeftLineIcon /> : <ArrowDropRightLineIcon />}
        </IconButton>
      </Toolbar>

      <LogoWrapper>
        <MainLogo />
        {open && (<Title> {t('app.slogan')} </Title>)}
      </LogoWrapper>

      <Box sx={{ width: '100%' }}>
        {items.map(group => (
          <NavGroup key={group.groupLabel} group={group} sidebarOpen={open} />
        ))}
      </Box>
    </Drawer>
  )
}

SideBar.propTypes = {
  open: PropTypes.bool,
  onChange: PropTypes.func,
}

export default SideBar
